import "babel-polyfill"
import "normalize.css"

// Change the import names to avoid conflict with export names
import { wrapRootElement as rootWrapper, browserWrapPageElement as pageWrapper } from "@src/wrappers"

// Re-export with the correct names
export const wrapRootElement = rootWrapper
export const wrapPageElement = pageWrapper


export const onRouteUpdate = ({ location, prevLocation }) => {
  // Check if our form tracking function exists and call it
  if (typeof window !== 'undefined' && window.___checkFormStarted) {
    window.___checkFormStarted()
  }

  if (location.hash) {
    const scrollToHash = (behavior = 'smooth') => {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior,
          block: 'start'
        })
      }
    }

    if (document.readyState === 'complete') {
      // Document already loaded, likely a subsequent navigation
      setTimeout(scrollToHash, 100)
    } else {
      // Document still loading, first load - wait for it to complete
      window.addEventListener('load', () => {
        setTimeout(scrollToHash, 100)
      }, { once: true })
    }
  }
}



export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // Don't scroll if there's a hash
  if (location.hash) {
    return false
  }
  return true
}
